module.exports = __webpack_public_path__ + "static/media/daverichardson_logo_small.0833e5dc.png";